import { Injectable } from '@angular/core';
import { FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class DateValidatorService {
  dateValidator(control :FormGroup): ValidationErrors | null {
    let compareParsedDate = control.value['DateFrom'];
    // standardize date
    // compareParsedDate = new Date(Date.UTC(compareParsedDate.getUTCFullYear(), compareParsedDate.getUTCMonth(), compareParsedDate.getUTCDate()));
    
    let inputDate = control.value['DateTo'];
    // inputDate = new Date(Date.UTC(inputDate.getUTCFullYear(), inputDate.getUTCMonth(), inputDate.getUTCDate()));

    if(compareParsedDate > inputDate){
      return { FromDateGreaterThanToDate: true };
    }
    return null;
  }}

  export const DateValidator: ValidatorFn = (
    control: FormGroup
): ValidationErrors | null => {
    const dateFrom = control.value['DateFrom'];
    const dateTo = control.value['DateTo'];
    return dateFrom && dateTo && dateFrom < dateTo
        ? null
        : { FromDateGreaterThanToDate: true };
};
